import { combineReducers } from 'redux';
import { cart } from './Reducers/Cart.reducer';
import { quickSearch } from './Reducers/QuickSearch.reducer';
import { navigation } from './Reducers/Navigation.reducer';
import { checkout } from './Reducers/Checkout.reducer';
import { myPage } from './Reducers/MyPage.reducer';
import { overlay } from './Reducers/Overlay.reducer';
import productFiltering from './Reducers/ProductFiltering.reducer';
import { productListing } from './Reducers/ProductListing.reducer';
import { search } from './Reducers/Search.reducer';
import { buyButton } from './Reducers/BuyButton.reducer';
import { login } from './Reducers/Login.reducer';
import { register } from './Reducers/Register.reducer';
import userInfoSlice from './Reducers/UserInfo.reducer';
import wishList from './Reducers/WishList.reducer';
import { pages } from './Reducers/Pages.reducer';
import { suggestedProducts } from './Reducers/SuggestedProducts.reducer';
import { orderSummary } from './Reducers/OrderSummary.reducer';
import { backofficeLogin } from './Reducers/BackofficeLogin.reducer';
import SelectedVariant from './Reducers/SelectedVariant.reducer';
import { vippsError } from './Reducers/VippsError.reducer';
import { favoriteButton } from './Reducers/FavoriteButton.reducer';
import sharedWishlist from './Reducers/SharedWishlist.reducer';
import { backInStockModal } from './Reducers/BackInStockModal.reducer';
import { quickSearchCategory } from './Reducers/QuickSearchCategory';

const staticReducers = {
  cart,
  quickSearch,
  navigation,
  checkout,
  myPage,
  overlay,
  productFiltering,
  productListing,
  search,
  buyButton,
  login,
  register,
  userInfo: userInfoSlice,
  wishList,
  pages,
  suggestedProducts,
  orderSummary,
  backofficeLogin,
  SelectedVariant,
  vippsError,
  favoriteButton,
  sharedWishlist,
  backInStockModal,
  quickSearchCategory,
};

const rootReducer = combineReducers(staticReducers);

export const createReducer = (asyncReducers: any) => {
  return combineReducers({
    ...staticReducers,
    ...asyncReducers,
  });
};

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
